<template>
<div ref="picker"></div>
</template>

<script>
import iro from '@jaames/iro';

export default {
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      colorPicker: null,
    };
  },
  methods: {
    onInput(color) {
      this.$emit('input', color.hsv);
    }
  },
  mounted() {
    this.colorPicker = new iro.ColorPicker(this.$refs.picker, {
      color: this.value,
      width: '240',
      wheelLightness: false
    });
    this.colorPicker.on('input:end', this.onInput);
  },
  beforeUnmount() {
    this.colorPicker.off('input:end', this.onInput);
  }
}
</script>
